import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, openModal } from "risa-oasis-ui_v2";
import BadgeDropdown from "../../../../components/badgeDropdown/badgeDropdown";
import ImageViewerWithBadgesModal from "../../../../components/modals/imageViewerWithBadgesModal/imageViewerWithBadgesModal";
import { createDataForWriteBackTrail } from "../../../../components/modals/imageViewerWithBadgesModal/utils/createDataForWriteBackTrail";
import RaiseQueryModal from "../../../../components/modals/raiseQueryModal/raiseQuery";
import { BusniessOfficeNote } from "../../../../data-model/busniessOfficeNote";
import { EVWriteBackStatus } from "../../../../enums/evBvWriteBackStatus";
import { ModalId } from "../../../../enums/modalId";
import { useAuthStatusDropdown } from "../../../../hooks/useAuthStatusDropdown";
import {
  setMetaData,
  setOpenedModalId,
} from "../../../../redux/slice/modalSlice";
import { AppDispatch, RootState } from "../../../../redux/store/store";
import InactiveWarningIcon from "../../../../svg/inactiveWarningIcon";
import RpaStatusCard from "../rpaStatusCard/rpaStatusCard";

export interface InactiveInsuranceProps {
  onCommentsChange: (comment: string) => void;
  queryType?: string;
  status?: string;
  id?: string;
  reports?: BusniessOfficeNote[];
}

const InactiveInsurance = (props: InactiveInsuranceProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const [writtenText, setWrittenText] = useState<string>("");
  const { openedModalId, metaData } = useSelector(
    (state: RootState) => state.modal,
  );
  useEffect(() => {
    if (openedModalId === ModalId.IMAGE_VIEWER_WITH_BADGES_MODAL) {
      openModal(ModalId.IMAGE_VIEWER_WITH_BADGES_MODAL);
    }
  }, [openedModalId]);

  useEffect(() => {
    setWrittenText(props?.queryType ?? "");
  }, [props?.queryType]);

  const { selectedAuthStatusBadge, handleAuthStatusChange, authStatusOptions } =
    useAuthStatusDropdown();
  const shouldShowRpaStatusCard = () => {
    if (props.status === EVWriteBackStatus.NOT_INITIATED) {
      return false;
    } else {
      return true;
    }
  };
  const handleRpaStatusCardIconClick = () => {
    props.status === EVWriteBackStatus.ERROR &&
      dispatch(setOpenedModalId({ id: ModalId.INSURANCE_ERROR_DIALOG }));
    props.status === EVWriteBackStatus.SUCCESS &&
      handleDisplayWriteBackTrailScreenshot(props?.id ?? "");
  };

  const handleDisplayWriteBackTrailScreenshot = async (id: string) => {
    try {
      dispatch(
        setOpenedModalId({
          id: ModalId.IMAGE_VIEWER_WITH_BADGES_MODAL,
          metaData: {
            showLoading: true,
          },
        }),
      );
      const dataForWriteBackTrail = await createDataForWriteBackTrail(
        id,
        authStatusOptions,
      );
      dispatch(
        setMetaData({
          tabs: dataForWriteBackTrail.tabs,
          showLoading: false,
        }),
      );
    } catch (error) {
      dispatch(
        setMetaData({
          tabs: [],
          showLoading: false,
        }),
      );
    }
  };
  return (
    <div className="coverage-inactive-container flex h-full w-full flex-col items-center justify-center border border-primaryGray-15">
      <div className="icon--container mr-12">
        <InactiveWarningIcon width="18rem" height="18rem" />
      </div>
      <div className="message--container mt-1 flex flex-col items-center justify-center gap-4">
        <div className="message--title text-center text-small text-primaryGray-3">
          The Insurance is inactive for the date <br /> of service
        </div>
        {shouldShowRpaStatusCard() ? (
          <RpaStatusCard
            status={props.status ?? ""}
            handleIconClick={handleRpaStatusCardIconClick}
          />
        ) : (
          <>
            <div className="trigger-button--container">
              <Button
                disabled={false}
                children={"Trigger RPA"}
                onClick={() => {
                  dispatch(
                    setOpenedModalId({ id: ModalId.INSURANCE_ERROR_DIALOG }),
                  );
                }}
                buttonType={"secondary"}
                size={"medium"}
              />
            </div>
          </>
        )}
      </div>
      <div className="mt-4 flex items-center gap-2">
        <div className="text-sm font-normal text-primaryGray-1">
          Select Auth Status
        </div>
        <BadgeDropdown
          selectedBadge={selectedAuthStatusBadge}
          badgeList={authStatusOptions}
          onClick={handleAuthStatusChange}
        />
      </div>
      {openedModalId === ModalId.IMAGE_VIEWER_WITH_BADGES_MODAL && (
        <ImageViewerWithBadgesModal
          tabs={metaData?.tabs ?? []}
          showLoading={metaData?.showLoading ?? false}
          title="Write Back Trail"
        />
      )}
      {openedModalId === ModalId.INSURANCE_ERROR_DIALOG && (
        <RaiseQueryModal
          onCommentsChange={(comment) => {
            setWrittenText(comment);
            props?.onCommentsChange(comment);
          }}
          queryType={
            writtenText ?? "Authmate Case: Insurance is inactive, please check"
          }
          reports={props?.reports ?? []}
        />
      )}
    </div>
  );
};

export default InactiveInsurance;
